/**
 *  自定义控件书写模板
 */
(function (KDApi, $) {
  // 构造函数，变量名随意，与最后一句代码的KDApi.register的第二个参数一致即可
  function ThemeSelect (model) {
    this._setModel(model)
  }
  const mockData = [
    {
      id: 'red',
      colorValue: '#E94E4F',
      description: {
        zh_CN: '魅力红'
      },
      isSelected: true
    },
    {
      isSelected: false,
      description: {
        zh_CN: '字段为空支持主体定制'
      },
      colorValue: '#45b97c',
      id: '1008'
    },
    //     {
    // id: "blue",
    // colorValue:"#666",
    // description:{
    //     "zh_CN": "魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿魅力绿"
    // },
    // isSelected: false
    // },
    {
      id: 'blue',
      colorValue: '#666',
      description: {
        zh_CN: '魅力绿'
      },
      isSelected: false
    },
    {
      id: 'blue',
      colorValue: '#666',
      description: {
        zh_CN: '魅力绿'
      },
      isSelected: false
    },
    {
      id: 'blue',
      colorValue: '#666',
      description: {
        zh_CN: '魅力绿'
      },
      isSelected: false
    },
    {
      id: 'blue',
      colorValue: '#666',
      description: {
        zh_CN: '魅力绿'
      },
      isSelected: false
    },
    {
      id: 'blue',
      colorValue: '#666',
      description: {
        zh_CN: '魅力绿'
      },
      isSelected: false
    },
    {
      id: 'blue',
      colorValue: '#666',
      description: {
        zh_CN: '魅力绿'
      },
      isSelected: false
    },
    {
      id: 'blue',
      colorValue: '#666',
      description: {
        zh_CN: '魅力绿'
      },
      isSelected: false
    },
    {
      id: 'blue',
      colorValue: '#666',
      description: {
        zh_CN: '魅力绿'
      },
      isSelected: false
    },
    {
      id: 'blue',
      colorValue: '#666',
      description: {
        zh_CN: '魅力绿'
      },
      isSelected: false
    },
    {
      id: 'blue',
      colorValue: '#666',
      description: {
        zh_CN: '魅力绿'
      },
      isSelected: false
    },
    {
      id: 'blue',
      colorValue: '#666',
      description: {
        zh_CN: '魅力绿'
      },
      isSelected: false
    },
    {
      id: 'blue',
      colorValue: '#666',
      description: {
        zh_CN: '魅力绿'
      },
      isSelected: false
    },
    {
      id: 'blue',
      colorValue: '#666',
      description: {
        zh_CN: '魅力绿'
      },
      isSelected: false
    }
  ]
  const _this = {}
  function getPosition () {
    const icon = document.getElementById('kd-custom-theme-icon')
    if (!icon) return {}
    const iconRect = icon.getBoundingClientRect()
    return {
      top: iconRect.top,
      right: iconRect.right
    }
  }

  function setDropDownPosition () {
    const dropdown = document.getElementById('kd-custom-dropdown')
    const offsetTop = 10
    const selfHeight = 14
    const pos = getPosition()
    // dropdown.classList.add("kd-custom-dropdown");
    dropdown.style.top = pos.top + selfHeight + offsetTop + 'px'
    dropdown.style.right = window.innerWidth - pos.right + 'px'
  }

  function getTargetKey (target) {
    let dataKey = target.dataset.key
    if (!dataKey && target !== document.body) {
      target = target.parentElement
      dataKey = getTargetKey(target)
      return parseInt(dataKey)
    }
    return parseInt(dataKey)
  }

  function isInteger (obj) {
    return obj % 1 === 0
  }

  function onClick (event, model, data) {
    const target = event.target
    const dataKey = getTargetKey(target)
    let key
    if (data instanceof Array && isInteger(dataKey)) {
      key = data[dataKey].id
      invokeService(model, 'click', { key: key })
      hideDropdown()
    }
    event.stopPropagation()
  }

  function toggleDropdown () {
    const dropdown = document.getElementById('kd-custom-dropdown')
    const dropdownShow = dropdown.classList.contains('kd-custom-dropdown-show')
    dropdownShow ? hideDropdown() : showDropdown()
  }

  function hideDropdown () {
    const dropdown = document.getElementById('kd-custom-dropdown')
    const icon = document.getElementById('kd-custom-theme-icon')
    icon.style.transform = 'rotate(0deg)'
    dropdown.classList.remove('kd-custom-dropdown-show')
    window.removeEventListener('click', clickOutSide, true)
    window.removeEventListener('resize', setDropDownPosition)
  }

  function showDropdown () {
    const dropdown = document.getElementById('kd-custom-dropdown')
    setDropDownPosition() // 隐藏时窗口resize
    const icon = document.getElementById('kd-custom-theme-icon')
    icon.style.transform = 'rotate(180deg)'
    dropdown.classList.add('kd-custom-dropdown-show')
    window.addEventListener('click', clickOutSide, true)
    window.addEventListener('resize', setDropDownPosition)
  }

  function addDropdownItemEventListner () {
    const dropdown = document.getElementById('kd-custom-dropdown')
    dropdown.addEventListener('click', function (e) { onClick(e, _this.model, _this.props.data || []) }, true)
  }

  function removeDropdownItemEventListner (model, props) {
    const dropdown = document.getElementById('kd-custom-dropdown')
    dropdown.removeEventListener('click', function (e) { onClick(e, _this.model, _this.props.data || []) }, true)
  }

  function clickOutSide (e) {
    const dropdown = document.getElementById('kd-custom-dropdown')
    const lang = document.getElementById('kd-custom-theme')
    const dialogDom = document.querySelector('#dialogShow') // 判断内容选择弹出层是否存在
    const targetDom = event.target
    let clickInSideslippingFlex = false
    const isNotificationDom = document.getElementById('kd-notification')?.contains(targetDom)
    const isSysNotificationDom = document.getElementById('system-notification')?.contains(targetDom)
    if (dialogDom || isNotificationDom || isSysNotificationDom) {
      clickInSideslippingFlex = true
    }
    if (clickInSideslippingFlex) return
    if (!dropdown.contains(e.target) && !lang.contains(e.target)) {
      hideDropdown()
      e.stopPropagation()
    }
  }

  function addButtonEvent () {
    const langEle = document.getElementById('kd-custom-theme')
    langEle.onclick = function (e) {
      e.stopPropagation()
      toggleDropdown()
    }
  }

  function createULElement () {
    const ul = document.createElement('ul')
    ul.id = 'kd-custom-dropdown'
    ul.classList.add('kd-custom-dropdown')
    document.body.appendChild(ul)
  }

  function clearDropdownItems () {
    const dropdown = document.getElementById('kd-custom-dropdown')
    if (dropdown) {
      dropdown.innerHTML = ''
    }
  }

  function createDropdownElement (props, lang) {
    createULElement()
    createDropdownItems(props, lang)
  }

  function updateDropdownItems (props, lang) {
    clearDropdownItems()
    createDropdownItems(props, lang)
  }

  function createDropdownItems (props, lang) {
    const dropdown = document.getElementById('kd-custom-dropdown')
    if (!dropdown) return
    if (props.data instanceof Array) {
      const fragment = document.createDocumentFragment()
      props.data.forEach(function (item, index) {
        const description = item.description[lang] || Object.values(item.description)[0]
        const li = document.createElement('li')
        if (item.isSelected) {
          li.classList.add('kd-custom-dropdown-item-selected')
        }
        li.classList.add('kd-custom-dropdown-item')
        li.innerHTML = `
                    <div style="background-color: ${item.colorValue}" class="kd-custom-theme-item-color"></div>
                    <div class="kd-custom-theme-item-description">${description} </div>
                `
        li.classList.add('kd-custom-theme-item')
        li.title = description
        li.setAttribute('data-key', index)
        fragment.appendChild(li)
      })
      dropdown.appendChild(fragment)
      setDropDownPosition()
    }
  }

  function invokeService (model, methodName, args) {
    model.invokeAsync(methodName, args)
  }

  function setDescValue (value) {
    const descEle = document.getElementById('kd-custom-theme-description')
    if (!descEle) return
    descEle.innerText = value
  }

  function setColorValue (value) {
    const colorEle = document.getElementById('kd-custom-theme-color')
    if (!colorEle) return
    colorEle.style.backgroundColor = value
  }

  function getSelectedValue (data) {
    return data.find(function (item) {
      return item.isSelected === true
    })
  }

  // 原型中封装生命周期函数，固定格式
  ThemeSelect.prototype = {
    _setModel: function (model) {
      this.model = model
    },
    init: function (props) {
      // TO DO
      _this.model = this.model
      _this.props = props
      initFunc()
    },
    update: function (props) {
      // TO DO  u指令更新数据
      _this.model = this.model
      _this.props = props
      const selectedValue = getSelectedValue(_this.props.data || [])
      const descValue = selectedValue.description[_this.props.lang || 'zh_CN'] || Object.values(selectedValue.description)[0]
      selectedValue && setDescValue(descValue)
      selectedValue && setColorValue(selectedValue.colorValue)
      updateDropdownItems(_this.props, _this.props.lang || 'zh_CN')
    },
    destoryed: function () {
      window.removeEventListener('click', clickOutSide, true)
      removeDropdownItemEventListner()
      _this.model = null
      _this.props = null
    }
  }

  // Other Code
  const initFunc = function () {
    window.KDApi.getTemplateStringByFilePath('./html/themeSelect.html', _this.model).then(function (result) {
      window.KDApi.loadFile('./css/index.css', _this.model, function () {
        _this.model.dom.innerHTML = result
        addButtonEvent()
        const selectedValue = getSelectedValue(_this.props.data || [])
        selectedValue && setDescValue(selectedValue.description[_this.props.lang || 'zh_CN'])
        selectedValue && setColorValue(selectedValue.colorValue)
        createDropdownElement(_this.props, _this.props.lang || 'zh_CN')
        addDropdownItemEventListner() // init里面监听会有问题
      })
    })
  }

  // 你只需知道第一个参数是你接下来要新增控件方案时填的方案id，第二个参数是上面声明的构造函数
  KDApi.register('themeselect', ThemeSelect)
})(window.KDApi, jQuery) // 这里的jQuery不是必须要传进去的，可移除，要用到的时候才传，PC端系统默认会有jQuery对象，版本是1.12.4
